/**
 * 浏览器工具函数
 *
 * @serverOnly false - 可在客户端和服务端使用
 */

/**
 * 获取浏览器版本
 * @returns 浏览器版本字符串，如 "Chrome 120.0.0" 或 "Unknown"
 */
export const getBrowserVersion = (): string => {
  // @ts-ignore
  if (typeof window === "undefined") {
    return "Unknown"
  }
  // @ts-ignore
  const ua = navigator.userAgent
  const regexes = {
    Chrome: /Chrome\/(\S+)/,
    Firefox: /Firefox\/(\S+)/,
    MSIE: /MSIE\/(\S+)/,
    Opera: /Opera\/(\S+)/,
    Safari: /Version\/(\S+) Safari\//,
  }
  for (const [key, val] of Object.entries(regexes)) {
    const match = ua.match(val)
    if (match) {
      return `${key} ${match[1]}`
    }
  }

  return "Unknown"
}
